import { render, staticRenderFns } from "./SetDefaultDiskModal.vue?vue&type=template&id=69f86d68&"
import script from "./SetDefaultDiskModal.vue?vue&type=script&lang=js&"
export * from "./SetDefaultDiskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f86d68')) {
      api.createRecord('69f86d68', component.options)
    } else {
      api.reload('69f86d68', component.options)
    }
    module.hot.accept("./SetDefaultDiskModal.vue?vue&type=template&id=69f86d68&", function () {
      api.rerender('69f86d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/SetDefaultDiskModal.vue"
export default component.exports